import CustomerFeatureItem from '@/components/megamenu/CustomerFeatureItem';

export const MegaMenuCustomerAboutUsContent = ({ menuItems }) => {
  return (
    <div className="h-[23rem] px-3 py-9 bg-[#fcfcff]">
      <div className="grid grid-cols-2 mt-4">
        {menuItems.map((item, index) => (
          <CustomerFeatureItem
            key={index}
            title={item.title}
            description={item.description}
            icon={item.icon}
            href={item.href}
          />
        ))}
      </div>
    </div>
  );
};
